const generateUID = () => {
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    var thirdPart = (Math.random() * 46656) | 0;
    var fourthPart = (Math.random() * 46656) | 0;
    var firstPartString = ("000" + firstPart.toString(36)).slice(-3);
    var secondPartString = ("000" + secondPart.toString(36)).slice(-3);
    var thirdPartString = ("000" + thirdPart.toString(36)).slice(-3);
    var fourthPartString = ("000" + fourthPart.toString(36)).slice(-3);
    return firstPartString+secondPartString+thirdPartString+fourthPartString;
};

export {generateUID};